import { reactive } from 'vue';
import type { WFabricWorld } from '@/littleWedding/WFabricWorld';
import type { TSides } from '@/typescript/interfaces/TSide';

class DataStore {
    public anyList: unknown[] = reactive([]); // any list
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public configuration: Record<string, any> = reactive({}); // configuration

    public wFabricWorldRecto: WFabricWorld;
    public wFabricWorldVerso: WFabricWorld;

    getFabricWorld(side: TSides) {
        if (side === 'verso') {
            return this.wFabricWorldVerso;
        }
        return this.wFabricWorldRecto;
    }

    clear() {
        this.anyList.length = 0;
        this.configuration = {};
    }

    toJSON() {
        return {
            anyList: this.anyList.map((element: unknown) => (element as { toJSON: () => unknown }).toJSON()),
            configuration: this.configuration,
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fromJSON(json: unknown) {
        // for (let i = 0; i < json?.anyList.length; i++) {
        // const newClass = new AnyClass();
        // newClass.fromJSON(json.anyList[i]);
        // this.anyList.push(newClass);
        // }
    }
}

const dataStore = new DataStore();

export { dataStore };
